(function () {
  // lite weight visual class which maps sprites on to the data descibed in ReelSpinnerData
  // has dependencies on Bulletproof libs and PIXI
  // it also implements the "interface" required by SlotMachine
  module.exports = class ReelSpinnerVisual extends PIXI.Container {
    // we should really think about passing in a data object rather than have so many params!
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      dynamicSpinner = false,
      nudgeReel,
      megawaysSymbolSpacing
    ) {
      super();
      let reelDataCreator;
      if (dynamicSpinner) {
        this._dynamicSpinner = true;
        reelDataCreator = require("../DynamicReelSpinnerData.js");
      } else {
        this._dynamicSpinner = false;
        reelDataCreator = require("../ReelSpinnerData.js");
      }
      this._symbolSpacing = minSpacing; // quick hack to get up and running
      this._nudgeReel = nudgeReel; // second quick hack to get up and running!!
      this._reelSpinnerData = reelDataCreator(
        reelId,
        maxAppertureHeight,
        this._symbolSpacing,
        reservedSpace || 1,
        numPreapp,
        numPostapp,
        megawaysSymbolSpacing,
        this._nudgeReel
      );
      this._symbolGfxObjects = [];
      this._symbolMovieName = "symbol";
      this._symbolMovieDescriptors = "staticSymbols";
      this._symbolOffset = [];
      this._suspendUpdates = false;
      this._symbolsToDim = [];
      this._slotMachineName = slotMach;
      let self = this;
      Reflex.registerEventHandler("orientationChange", function () {
        if (!self._suspendUpdates) {
          self.updateSymbols();
        }
      });
      this.initialiseSymbolOffsets(resourceManager.configuration.symbols);

      Reflex.registerEventHandler("ready", this.onLayoutComplete.bind(this));
    }

    onLayoutComplete() {
      let slotMachine = resourceManager.getController(this._slotMachineName);
      this.assignSlotMachine(slotMachine);

      // This is a temporary hack - need good point to tell spinner when to load injector
      // and initialise symbol data. Visual needs to be setup before this point
      if (this._dynamicSpinner) {
        this._reelSpinnerData.onLayoutComplete();
      }
    }

    initialise(json) {
      this.createAccessorsForGlobalObjects();
      this.createSprites(json);
      this.createClipRect(json.clipRect);
      this._clipRect = json.clipRect;
      this._dimTint = json.dimTint || 0x777777;
      this._oversizedSymbolIds = json.oversizedSymbolIds || [];
    }

    reset() {}

    initialiseSymbolOffsets(symbolData) {
      this._symbolOffset = new Array(Object.keys(symbolData).length).fill({
        x: 0,
        y: 0,
      });
      for (let prop in symbolData) {
        if (symbolData.hasOwnProperty(prop) && symbolData[prop].offset) {
          let data = symbolData[prop];
          this._symbolOffset[Number(data.ID)] = data.offset;
        }
      }
    }

    assignSlotMachine(slotMachine) {
      this._slotMachine = slotMachine;
      if (this._slotMachine) {
        this._slotMachine.addReel(this._reelSpinnerData);
        this._slotMachine.addReelVisual(this);
      }
    }

    unassignSlotMachine() {
      if (this._slotMachine) {
        this._slotMachine.removeReel(this._reelSpinnerData);
        this._slotMachine.removeReelVisual(this);
      }
    }

    reassignSlotMachine(newSlot) {
      this.unassignSlotMachine();
      this.assignSlotMachine(newSlot);
    }

    getReelSpinnerData() {
      return this._reelSpinnerData;
    }

    setReelSymbol(index, symbolId) {
      // index represents relative window. So 0 is top of window. Nice and easy
      this._reelSpinnerData.setReelSymbol(index, symbolId);
    }

    suspendUpdates() {
      this._suspendUpdates = true;
    }

    clearSuspendUpdates() {
      this._suspendUpdates = false;
    }

    update(delta) {
      this._reelSpinnerData.update(delta);

      if (!this._suspendUpdates) {
        this.updateSymbols();
      }
    }

    forceSymbolsTo(symbols) {
      const symbolData = this._reelSpinnerData.getSymbolData();
      for (let i = 0; i < symbolData.length; i++) {
        if (typeof symbols[i] === "number") {
          symbolData[i].symId = symbols[i];
        }
      }
    }

    updateSymbolIds(ids) {
      for (let i = 0; i < ids.length; ++i) {
        let symId = ids[i];
        this._symbolGfxObjects[i].symbol.gotoAndStop(symId);
        if (this._symbolsToDim.length > 0) {
          if (this._symbolsToDim.indexOf(symId) !== -1) {
            this.dimSymbol(i, true, 0);
          } else {
            this.dimSymbol(i, false, 0);
          }
        }
      }
    }

    updateSymbolPositions(positions) {
      for (let i = 0; i < positions.length; ++i) {
        let pos = positions[i];
        this._symbolGfxObjects[i].position.setX(pos.x);
        this._symbolGfxObjects[i].position.setY(pos.y);
      }
    }

    updateSymbolOverlays(ids, overlays) {
      // This function allows us to store data in overlays that can be used
      // by game-side component. It swaps positions like updateSymbolIds does
      this.updateSymbolIds(ids);
    }

    showSymbol(index, show) {
      this._symbolGfxObjects[index].visible = show;
    }

    getSymbolPosition(index) {
      //let globalPos = this._symbolGfxObjects[index].getGlobalPosition();
      let thisPos = this.position;
      let parentPos = this.parent.parent.position;
      let symbolData = this._reelSpinnerData.getSymbolData();
      let symId = symbolData[index].symId;
      let offset = this._symbolOffset[symId];

      return {
        x:
          parentPos.getX() +
          this._symbolGfxObjects[index].position.getX() +
          thisPos.getX() -
          offset.x,
        y:
          parentPos.getY() +
          this._symbolGfxObjects[index].position.getY() +
          thisPos.getY() -
          offset.y,
      };
    }

    // function to map the symbol Ids on the data object to the visual sprites
    updateSymbols() {
      let symbolData = this._reelSpinnerData.getSymbolData();

      let ids = [];
      let positions = [];
      let overlays = [];

      for (let i = 0; i < symbolData.length; ++i) {
        ids.push(symbolData[i].symId);
        overlays.push(symbolData[i].overlayData);

        let offset = this._symbolOffset[symbolData[i].symId];
        let yPos = symbolData[i].yPos + offset.y;
        positions.push({ x: offset.x, y: yPos });

        if (this._oversizedSymbolIds.indexOf(symbolData[i].symId) !== -1) {
          this.setChildIndex(
            this._symbolGfxObjects[i],
            this.children.length - 1
          );
        }
      }
      this.updateSymbolIds(ids);
      this.updateSymbolPositions(positions);
      this.updateSymbolOverlays(ids, overlays);
    }

    startSpin() {
      this._reelSpinnerData.startSpin();
    }

    // Doesn't do anything for now, but game specific visual classes can override this
    startDynamicSpin() {}

    // Again, just something the game specific visual classes can override
    dynamicSpinComplete() {}

    // chane the number of symbols that fit fully in the window
    setAppertureHeight(numInWindow) {
      this._reelSpinnerData.setAppertureHeight(numInWindow);
    }

    dimSymbol(row, showDim, duration) {
      let self = this;
      let targetTint = showDim ? this._dimTint : 0xffffff;

      const symbol = self._symbolGfxObjects[row].symbol;

      gsap.killTweensOf(symbol);

      if (duration) {
        gsap.to(symbol, {
          duration,
          pixi: { tint: targetTint },
        });
      } else {
        symbol.tint = targetTint;
      }
    }

    dimSymbolIds(symbolsToDim, duration = 0) {
      this._symbolsToDim = symbolsToDim;
      let symbolData = this._reelSpinnerData.getSymbolData();
      for (let i = 0; i < symbolData.length; ++i) {
        let symId = symbolData[i].symId;
        if (this._symbolsToDim.indexOf(symId) !== -1) {
          this.dimSymbol(i, true, duration);
        }
      }
    }

    clearDimSymbolIds(duration = 0) {
      this._symbolsToDim = [];
      let symbolData = this._reelSpinnerData.getSymbolData();
      for (let i = 0; i < symbolData.length; ++i) {
        this.dimSymbol(i, false, duration);
      }
    }

    getClipRect() {
      let thisPos = this.position;
      let parentPos = this.parent.parent.position;

      let res = {
        width: this._clipRect.width,
        height: this._clipRect.height,
        x: thisPos.getX() + parentPos.getX(),
        y: thisPos.getY() + parentPos.getY(),
      };

      return res;
    }

    createClipRect(clipRectData) {
      this.mask = new PIXI.Graphics();
      this.mask.beginFill(0x000000, 0);
      this.mask.drawRect(
        clipRectData.x,
        clipRectData.y,
        clipRectData.width,
        clipRectData.height
      );
      this.mask.endFill();
      this.addChild(this.mask);
    }

    createAccessorsForGlobalObjects() {
      // I dont like configParams but game code and library code uses it directly. So I am defining it as a property and forwarding it to the data class.
      // This is because the configParams may change especially in Megaways games that have dynamic symbol/apperture sizes. This way
      // I dont need to constantly keep a configParams variable synchronised with ReelSpinnerData as configParams is recreated everytime
      // it gets queried by game and lib code
      let dataClass = this.getReelSpinnerData();
      Object.defineProperty(this, "configParams", {
        get: function () {
          return {
            totalAppertureSize: dataClass.getTotalAppertureSize(),
            preappertureSymbols: dataClass.getPreappertureSymbols(),
          };
        },
      });
    }

    createSprites(json) {
      let anchor = json.anchor || 0;
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        // parent container for this symbol
        let gfxObject = new resourceManager.createObject(
          "container",
          "symbol" + i,
          this
        );

        // is there a background image?
        if (json.useContainer.background) {
          gfxObject.background = resourceManager.createObject(
            "container",
            "backgroundContainer",
            gfxObject.name
          );
        }
        // the actual symbols
        gfxObject.symbol = resourceManager.createObject(
          "movie",
          this._symbolMovieName,
          gfxObject.name,
          {
            definition: this._symbolMovieDescriptors,
            cloneTextures: true,
            anchor: anchor,
          }
        );
        // any child objects of the symbol. Tit
        if (json.useContainer.child) {
          gfxObject.symbol.childContainer = resourceManager.createObject(
            "container",
            "childContainer",
            gfxObject.symbol.name
          );
        }
        // any foreground object
        if (json.useContainer.foreground) {
          gfxObject.foreground = resourceManager.createObject(
            "container",
            "foregroundContainer",
            gfxObject.name
          );
        }

        this._symbolGfxObjects.push(gfxObject);
      }

      if (this._symbolSizes && this._symbolSizes.length > 0) {
        this.scaleToImageSize();
      }
    }
  };

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 2;
    return new ReelSpinnerVisual(
      json.ID,
      json.ID + " container",
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp
    );
  }

  function initialse(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType(
    "ReelSpinnerVisualEx",
    create,
    initialse,
    getRequiredFiles
  );
})();
